import { Typography } from "@mui/material";
import React from "react";

function ValidationMessage({ message }) {
  return (
    <div style={{marginTop: 5}}>
      <Typography style={{ color: "red", fontSize: "12px" }}>
        {message}
      </Typography>
    </div>
  );
}

export default ValidationMessage;
